module.exports = __webpack_public_path__ + "img/16d001-12.149b144c.png";